import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3IVCurveScanSettings } from 'ngx-modbus';

export const IV_CURVE_SCAN_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'iv-curve-scan-settings',
  name: 'IV Curve Scan Settings',
  sections: [{
    id: 'iv-curve',
    labelKey: 'IVCurveScanSettings',
    registerTable: 'V3IVCurveScanSettings',
    fields: [
      fieldRef(V3IVCurveScanSettings, 'IVCurveScan_Control'),
      fieldRef(V3IVCurveScanSettings, 'IVCurveScan_Period'),
    ],
  }],
};
